import React, { useState } from 'react';
import { useListFeatureRoles } from './hooks/useListFeatureRoles';
import { FeatureRolesTable } from './FeatureRolesTable';
import { CreateFeatureRoleForm } from './subComponents/CreateFeatureRoleForm';
import { FeaturePresentationCard } from './FeaturePresentationCard';

export const FeatureRolesContainer: React.FC = () => {
  const { sortedFeatureRoleData, isFeatureRoleFetching, featureRoleError } = useListFeatureRoles();
  const [addFeatureRole, setAddFeatureRole] = useState(false);

  const handleAddClick = () => {
    setAddFeatureRole(true);
  };

  const onCancel = () => {
    setAddFeatureRole(false);
  };

  return (
    <FeaturePresentationCard
      featureFetchError={featureRoleError}
      data-test-id={'features-roles-page'}
      title={'Features By Role'}
      hintText={'Allow specific roles to access features.'}
      buttonText={'Add New Feature for Role'}
      handleAddClick={handleAddClick}
    >
      {addFeatureRole && <CreateFeatureRoleForm onCancel={onCancel} />}
      <FeatureRolesTable data={sortedFeatureRoleData} isFetching={isFeatureRoleFetching} />
    </FeaturePresentationCard>
  );
};
